import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { getProducts } from '../../mobileMenuProducts'
import { AccordionMenu } from '../AccordionMenu'
import { ConsumerCallout } from './ConsumerCallout'

const Search = dynamic(
  () => import('components/Navigation/shared/Mobile/Search'),
  { ssr: false },
)

export const MobileMenuVariant2 = ({
  newForBusinessPageEnabled = false,
}: {
  newForBusinessPageEnabled?: boolean
}) => {
  const { pathname, query } = useRouter()

  const PRODUCTS = getProducts({
    pathname,
    query: query as Record<string, string>,
    newForBusinessPageEnabled,
    Callout: <ConsumerCallout />,
    productType: 'consumer',
  })

  return (
    <>
      <Search />
      <AccordionMenu
        products={PRODUCTS}
        defaultExpandedProduct='consumer'
        productSectionClassName='mc-bg-container-tint-medium'
      />
    </>
  )
}
